module.exports = __webpack_public_path__ + "frontend/images/favicons/mstile-150x150.png?a163b5c50d94725689b656ab06b43c3b";